import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type {
  InvitationType,
  InvitationTypeStatus,
  InvitationTypeUpsert,
  PagedResponse,
} from '../types'

const BASE = '/management/activity-invitation-types'

/** Silinmemiş kayıtların (sıralı) listesi. Lookup ölçeği küçük → tümünü tek sayfada çekeriz (size=200). */
export async function getInvitationTypes(): Promise<PagedResponse<InvitationType>> {
  const { data } = await apiClient.get<PagedResponse<InvitationType>>(BASE, {
    params: { page: 0, size: 200 },
  })
  return data
}

/** Yeni kayıt oluştur (201 → oluşturulan kayıt). */
export async function createInvitationType(body: InvitationTypeUpsert): Promise<InvitationType> {
  const { data } = await apiClient.post<InvitationType>(BASE, body)
  return data
}

/** Kaydı güncelle (ad; optimistic lock modDate zorunlu). */
export async function updateInvitationType(
  id: number,
  body: InvitationTypeUpsert,
): Promise<InvitationType> {
  const { data } = await apiClient.put<InvitationType>(`${BASE}/${id}`, body)
  return data
}

/** Durum değiştir (Aktif/Pasif; yalnız 0↔1). */
export async function changeInvitationTypeStatus(
  id: number,
  body: InvitationTypeStatus,
): Promise<InvitationType> {
  const { data } = await apiClient.put<InvitationType>(`${BASE}/${id}/status`, body)
  return data
}

/** Soft-delete (record_status=2). 204. */
export async function deleteInvitationType(id: number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}`)
}

/**
 * Yeniden sıralama — ekranda görünen tüm (silinmemiş) kayıtların id sırası. Backend bu sırayı 1..N
 * SORT_INDEX olarak yeniden yazar (pairwise takas değil; çift değeri onarır). 204.
 */
export async function reorderInvitationTypes(orderedIds: number[]): Promise<void> {
  await apiClient.put(`${BASE}/reorder`, { orderedIds })
}

/**
 * Davet türü listesini Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportInvitationTypes(): Promise<void> {
  await downloadXlsx(`${BASE}/export`, {}, 'davet-turleri.xlsx')
}
